/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { classNames as l } from "@progress/kendo-react-common";
const u = e.forwardRef(({ orientation: r = "vertical", ...t }, n) => {
  const a = e.useRef(null), s = e.useRef(null);
  return e.useImperativeHandle(
    a,
    () => ({ element: s.current })
  ), e.useImperativeHandle(
    n,
    () => a.current
  ), /* @__PURE__ */ e.createElement("span", { ...t, className: l("k-input-separator", t.className, `k-input-separator-${r}`) });
});
u.displayName = "KendoReactInputSeparator";
export {
  u as InputSeparator
};
